import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { needsCanonicalRedirect, redirectToCanonicalBaseDomain } from '../utils/adminHost';

// requireFullAdmin gates a route to FullAdmins only — e.g. the global
// /admin/main area (school creation, all-users management). SchoolAdmins
// hitting the URL directly get redirected to /admin (their school picker)
// rather than seeing a broken/empty page.
function ProtectedRoute({ children, requireFullAdmin }) {
  const { isAuthenticated, isFullAdmin, loading } = useAuth();

  // Every admin/logged-in route lives on the bare base domain, never a
  // school's subdomain (see utils/adminHost.js) — covers a stale bookmark
  // or shared link like lhms.lunchday.app/admin/orders. The auth token
  // lives in that school subdomain's own localStorage, so this reloads as
  // logged-out on the base domain; login there (which itself is already
  // pinned to the base domain — see Login.js) is the recovery path.
  useEffect(() => {
    redirectToCanonicalBaseDomain();
  }, []);

  if (needsCanonicalRedirect()) {
    return null;
  }

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '50vh',
        fontSize: '1.2rem',
        color: '#666'
      }}>
        Loading...
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requireFullAdmin && !isFullAdmin) {
    return <Navigate to="/admin" replace />;
  }

  return children;
}

export default ProtectedRoute;
